
import { SEARCH_OPTION } from "./SearchOption.jsx";

export const   DROPDOWN_OPTION = {

    PAID_STATUS : [
     { name: 'ALL INVOICE', code: 0 },
     { name: 'F UNPAID INVOICE', code: 1 },
     { name: 'PARTIAL PAID', code: 2 },
     { name: 'FULLY PAID', code: 3 },
     {name:'CREDIT INVOICES' , code:5}
   ],

   TOTAL_BY:[
    {name:'TOTAL BY COST PRICE', code:0},
    {name:'TOTAL BY RETAIL PRICE', code :1}

   ],

   SEARCH_BY:[
    {name:'Barcode', code:SEARCH_OPTION.BARCODE},
    {name:"Name",code: SEARCH_OPTION.NAME},
    {name:"Description", code:SEARCH_OPTION.DESCRIPTION},
    // {name:"Category",code:SEARCH_OPTION.CATEGORY},
    // {name:"Brande", code:SEARCH_OPTION.BARND},
   ]
}
